import PropTypes from "prop-types";
import React from "react";
import {first, isArray} from "lodash";
import TextField from "react-md/lib/TextFields";

const FocusedInputField = ({
  input,
  type,
  meta,
  hintText,
  id,
  rows,
  disabled,
  dataTest,
  containerClassName
}) => {
  // we will display the error message, only if
  // the field has been edited to a new value

  // If you want to change whether or not the hint text will eternally float above the field
  // without requiring focus or an an event to fill the field then set the floating attribute of Textfield to true
  // as described here: https://react-md.mlaursen.com/components/text-fields?tab=1#text-field-proptypes-floating
  
  const isInvalidate = meta.touched && meta.error && !!meta.error.length;
  const errorMessage = isInvalidate
    ? (isArray(meta.error) ? first(meta.error) : meta.error)
    : "";
  return (
    <div className={`input-field-wrapper ${containerClassName}`}>
      <TextField
        {...input}
        value={input.value}
        rows={rows}
        type={type}
        label={hintText}
        id={id}
        disabled={disabled}
        data-test={dataTest}
        floating={true}
      />
      <div className="validation-error" 
        data-test={`${dataTest}-error`}>
          {errorMessage}
      </div>
    </div>
  );
};

FocusedInputField.propTypes = {
  input: PropTypes.object.isRequired,
  type: PropTypes.string,
  meta: PropTypes.object.isRequired,
  hintText: PropTypes.string,
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  dataTest: PropTypes.string,
  rows: PropTypes.number,
  containerClassName: PropTypes.string
};

export default FocusedInputField;

